/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Kanban_No_State_LabelInputs */



/**
* | output |
* | --- |
* | "No State" |
*
* @param {Explorer_Kanban_No_State_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_kanban_no_state_label = /** @type {((inputs?: Explorer_Kanban_No_State_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Kanban_No_State_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Sans etat")
	if (locale === "de") return /** @type {LocalizedString} */ ("Kein Staat")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessuno Stato")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Нет государства")
	if (locale === "es") return /** @type {LocalizedString} */ ("Sin Estado")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("无州")
	if (locale === "ja") return /** @type {LocalizedString} */ ("州なし")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कोई राज्य नहीं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Nenhum estado")
	return /** @type {LocalizedString} */ ("No State")
});